var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTrainingNumber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_training_number",
    transform: "translate(-777.224 -173.42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u6955\\u5186\\u5F62_15",
    "data-name": "\\u6955\\u5186\\u5F62 15",
    transform: "translate(777.224 173.42)",
    fill: "#f5fafc",
    stroke: "#0071b9",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 47,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 45.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_74",
    "data-name": "\\u30D1\\u30B9 74",
    d: "M-24.139-19.8v-4.257h7.953V0h-4.752V-19.8ZM-10.18-5.214q3.168-2.64,5.049-4.405A20.423,20.423,0,0,0-2-13.3,6.852,6.852,0,0,0-.742-17.061a4.022,4.022,0,0,0-.792-2.64,2.988,2.988,0,0,0-2.442-.957,3.075,3.075,0,0,0-2.541,1.105,4.818,4.818,0,0,0-.924,3.02h-4.488A8.142,8.142,0,0,1-9.57-22.539a8.042,8.042,0,0,1,5.66-2.046,7.854,7.854,0,0,1,5.775,2,7.084,7.084,0,0,1,2.013,5.264,9.515,9.515,0,0,1-1.386,4.917A19.459,19.459,0,0,1-.676-8.332Q-2.458-6.6-5.329-4.158H4.405V-.33H-11.9V-3.762ZM7.376-17.721a6.728,6.728,0,0,1,2.327-5.1,8.609,8.609,0,0,1,5.693-1.8,9.289,9.289,0,0,1,4.125.841A6.056,6.056,0,0,1,22.11-21.5a6.123,6.123,0,0,1,.875,3.251,5.705,5.705,0,0,1-1.073,3.514,5.256,5.256,0,0,1-2.557,1.93v.132a5.547,5.547,0,0,1,2.986,2.112,6.594,6.594,0,0,1,1.073,3.894,6.861,6.861,0,0,1-.908,3.531A6.176,6.176,0,0,1,19.833-.71a9.468,9.468,0,0,1-4.24.875A9.4,9.4,0,0,1,9.521-1.716,7.035,7.035,0,0,1,7.046-7.26h4.488a3.594,3.594,0,0,0,1.106,2.59,4.01,4.01,0,0,0,2.854.973,3.433,3.433,0,0,0,2.591-.94,3.348,3.348,0,0,0,.907-2.426A3.189,3.189,0,0,0,17.738-9.9a7,7,0,0,0-3.894-.858h-.957v-3.8h.957q4.686,0,4.686-3.135a2.889,2.889,0,0,0-.841-2.211,3.408,3.408,0,0,0-2.426-.792,3.236,3.236,0,0,0-2.392.842,3.4,3.4,0,0,0-.973,2.128Z",
    transform: "translate(824.224 233.42)",
    fill: "#0071b9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrainingNumber);
export default __webpack_public_path__ + "static/media/icon_training_number.2de740aed9ed145bed043382427be930.svg";
export { ForwardRef as ReactComponent };